export const format = (str: string, ...values: Array<any>): string => {
    let i: number = 0;
    return str.replace(/{}/g, () => values[i++] ?? '');
}

/**
 * Restituisce true se la stringa è null, undefined, vuota
 * o contiene solo spazi.
 */
export const isNullOrEmpty = function (value?: string | null): boolean {
  return !value?.trim();
}